import type ProfileStore from "../../../stores/ProfileStore";
import type AuthStore from "../../../authentication/AuthStore";
import type {MithraMaterializedApi} from "../../../services/MithraMaterializedApi";
import {makeAutoObservable} from "mobx";
import type {BusinessCaseGeneratorPageController, Page} from "./BusinessCaseGeneratorPageController";
import type {BusinessCaseGeneratorPageStateController} from "./BusinessCaseGeneratorPageStateController";

/**
 * This reactive controller is responsible for the state of the grouped review table.
 */
export class BusinessCaseGeneratorPageDataController {

    constructor(
        private businessCaseGeneratorPageController: BusinessCaseGeneratorPageController,
        private businessCaseGeneratorPageStateController: BusinessCaseGeneratorPageStateController,
        private matApi: MithraMaterializedApi,
        private auth: AuthStore,
        private profile: ProfileStore,
    ) {
        makeAutoObservable(this)
    }

    navigateToPage(page: Page) {
        this.businessCaseGeneratorPageStateController.setPage(page);
    }

}
